import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Sidebar } from '../sidebar/Sidebar';
import logoImage from '../../assets/light_logo.png';

interface DocLayoutProps {
  children: React.ReactNode;
}

export const DocLayout: React.FC<DocLayoutProps> = ({ children }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-dark">
      {/* Header */}
      <header className="bg-dark/90 backdrop-blur-md border-b border-white/10 fixed w-full top-0 z-30 shadow-lg">
        <div className="mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex justify-between items-center h-16">
            <div className="flex items-center">
              <div className="flex-shrink-0 flex items-center">
                <div className="flex flex-col">
                  <img 
                    src={logoImage} 
                    alt="NectarOS Logo" 
                    className="w-[100px] sm:w-[130px] object-cover"
                  />
                  <div className="mt-1">
                    <p className="text-xs text-white-muted">Documentation</p>
                  </div>
                </div>
              </div>
            </div>
            <div className="flex items-center space-x-3">
              {/* <span className="hidden sm:inline-flex items-center px-3 py-1 rounded-full text-xs font-medium bg-lime/20 text-lime border border-lime/30">
                v1.0.0
              </span> */}
              <button
                onClick={() => setSidebarOpen(true)}
                className="p-2 rounded-lg text-white-muted hover:text-white hover:bg-white/10 focus:outline-none focus:ring-2 focus:ring-lime lg:hidden transition-colors"
              >
                <Menu className="h-5 w-5" />
              </button>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile sidebar */}
      <div className={`fixed inset-0 z-40 lg:hidden ${sidebarOpen ? '' : 'pointer-events-none'}`}>
        <div
          className={`fixed inset-0 bg-black bg-opacity-75 transition-opacity ${
            sidebarOpen ? 'opacity-100' : 'opacity-0'
          }`}
          onClick={() => setSidebarOpen(false)}
        />
        <div
          className={`fixed top-0 left-0 bottom-0 flex flex-col w-full max-w-xs sm:w-80 bg-sidebar-bg shadow-2xl transform transition-transform ${
            sidebarOpen ? 'translate-x-0' : '-translate-x-full'
          }`}
        >
          <div className="flex items-center justify-between h-16 px-6 bg-sidebar-bg border-b border-white/10">
            <img 
              src={logoImage} 
              alt="NectarOS Logo" 
              className="w-[100px] object-cover"
            />
            <button
              onClick={() => setSidebarOpen(false)}
              className="text-sidebar-text hover:text-white p-1 rounded-md transition-colors"
            >
              <X className="h-5 w-5" />
            </button>
          </div>
          <div className="flex-1 overflow-y-auto">
            <Sidebar />
          </div>
        </div>
      </div>

      {/* Desktop layout */}
      <div className="lg:flex lg:fixed lg:inset-y-0 lg:left-0 lg:w-80">
        <div className="hidden lg:flex lg:flex-col lg:w-80 lg:bg-sidebar-bg lg:border-r lg:border-white/10 lg:pt-16 shadow-lg">
          <div className="flex-1 overflow-y-auto">
            <Sidebar />
          </div>
        </div>
      </div>

      {/* Main content */}
      <div className="lg:pl-80 pt-16">
        <main className="flex-1 p-4 sm:p-6 lg:p-8">
          {children}
        </main>
      </div>
    </div>
  );
};